export default __webpack_public_path__ + "static/media/icon-only.debf3473.png";